import type { AuthorizationMethod } from "../../types/authorization-method";
import type { BasicDTO } from "../vouchers-distribution.types";
import type { ValidateUserDTO } from "./validate-user.types";

export const createValidateUserDTO = (
  authorizationMethod: AuthorizationMethod,
  baseData: BasicDTO,
  userData: { externalUid?: string; email?: string },
): ValidateUserDTO => {
  if (authorizationMethod === "external_uid_authorization") {
    if (!userData.externalUid) {
      throw new Error("externalUid is required");
    }
    return { ...baseData, externalUid: userData.externalUid };
  }

  if (authorizationMethod === "email_authorization") {
    if (!userData.email) {
      throw new Error("email is required");
    }
    return { ...baseData, email: userData.email };
  }

  return { ...baseData };
};
